module.exports = __webpack_public_path__ + "static/media/Keyboard.2949e91f.svg";